import Vue from 'vue'
import Vuex from 'vuex'

import bbrbbr from './modules/bbrbbr_alt'
import bearbeitungen from './modules/bearbeitungen_alt'
import bierlieferungen from './modules/bierlieferungen_alt'
import dateien from './modules/dateien_alt'
import couleurstrafen from './modules/couleurstrafen_alt'
import dokumente from './modules/dokumente_alt'
import einstellungen from './modules/einstellungen_alt'
import getranke from './modules/getranke_alt'
import getrankeStand from './modules/getrankeStand_alt'
import kassenbucher from './modules/kassenbucher_alt'
import kontobucher from './modules/kontobucher_alt'
import mails from './modules/mails_alt'
import news from './modules/news_alt'
import rechnungen from './modules/rechnungen_alt'
import sepa from './modules/sepa_alt'
import statistiken from './modules/statistiken_alt'
import striche from './modules/striche_alt'
import user from './modules/user_alt'
import veranstaltungen from './modules/veranstaltungen_alt'
import vereine from './modules/verein_alt'
import wirtschaftsplane from './modules/wirtschaftsplane_alt'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    bbrbbr,
    bearbeitungen,
    bierlieferungen,
    dateien,
    couleurstrafen,
    dokumente,
    einstellungen,
    getranke,
    getrankeStand,
    kassenbucher,
    kontobucher,
    mails,
    news,
    rechnungen,
    sepa,
    statistiken,
    striche,
    user,
    veranstaltungen,
    vereine,
    wirtschaftsplane
  },
  state: {
    nachricht: {
      titel: '',
      typ: '',
      nachricht: '',
      error: '',
      show: false
    },
    snackbar: {
      show: false,
      nachricht: '123'
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js